import { AbsoluteCenter, Spinner, VStack } from "@chakra-ui/react";
import CDS from "design-system";
import { SHARED_ROUTES } from "definitions/constants/routeConstants";
import useCaminoStore from "hooks/useCaminoStore";
import { useEffect } from "react";
import { redirect } from "react-router";

export default function AuthenticatePage() {
  const currentUser = useCaminoStore((state) => state.currentUser);

  useEffect(() => {
    if (currentUser) redirect(SHARED_ROUTES.home);
  }, [currentUser]);

  return (
    <AbsoluteCenter>
      <VStack spacing={4}>
        <CDS.Text14>Authenticating...</CDS.Text14>
        <Spinner />
      </VStack>
    </AbsoluteCenter>
  );
}
